export const LEAVE_INITIAL_STATE={
    "leave_type_name": ""
}